import React from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import CapabilityCircle from '../../user/CapabilityCircle';

export default function CarrierStatus({ userType, rows }) {
  const { t } = useTranslation();

  return (
    <table className="mt-6 default-table">
      <thead>
        <tr>
          {userType === 'shipper' && <th>{t('SHIPPER')}</th>}

          {userType === 'carrier' && <th>{t('CARRIER')}</th>}
          <th>{t('STATUS')}</th>
          <th>{t('MESSAGE')}</th>
        </tr>
      </thead>
      <tbody>
        {rows.map((row) => (
          <CarrierRow key={row.shipper} row={row} />
        ))}
      </tbody>
    </table>
  );
}

function CarrierRow({ row }) {
  const { userId, status, success, name } = row;
  function renderCarrierRowLink() {
    const link = `/users/${userId}`;
    return (
      <Link to={link}>
        <span>{name}</span>
      </Link>
    );
  }

  return (
    <tr>
      <td>{renderCarrierRowLink()}</td>
      <td>
        <CapabilityCircle checked={success} />
      </td>
      <td>{status}</td>
    </tr>
  );
}
